"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCIENTISTS_POLICY_4 = exports.SCIENTISTS_POLICY_3 = exports.SCIENTISTS_POLICY_2 = exports.SCIENTISTS_DEFAULT_POLICY = exports.SCIENTISTS_BONUS_2 = exports.SCIENTISTS_BONUS_1 = exports.Scientists = void 0;
const Party_1 = require("./Party");
const PartyName_1 = require("./PartyName");
const Tags_1 = require("../../cards/Tags");
const Resources_1 = require("../../Resources");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const TurmoilPolicy_1 = require("../TurmoilPolicy");
const MarsCoalition_1 = require("../../cards/community/corporations/MarsCoalition");
const ScientistsDefaultAction_1 = require("../../cards/turmoil/standardActions/ScientistsDefaultAction");
class Scientists extends Party_1.Party {
    constructor() {
        super(...arguments);
        this.name = PartyName_1.PartyName.SCIENTISTS;
        this.description = 'Tech is the door to the future, and Scientists will do anything to open it.';
        this.bonuses = [exports.SCIENTISTS_BONUS_1, exports.SCIENTISTS_BONUS_2];
        this.policies = [exports.SCIENTISTS_DEFAULT_POLICY, exports.SCIENTISTS_POLICY_2, exports.SCIENTISTS_POLICY_3, exports.SCIENTISTS_POLICY_4];
    }
}
exports.Scientists = Scientists;
class ScientistsBonus01 {
    constructor() {
        this.id = 'sb01';
        this.isDefault = true;
        this.description = 'Gain 1 M€ for each Science tag you have';
    }
    getScore(player) {
        return player.getTagCount(Tags_1.Tags.SCIENCE, 'raw');
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class ScientistsBonus02 {
    constructor() {
        this.id = 'sb02';
        this.description = 'Gain 1 M€ for every 3 cards in hand';
        this.isDefault = false;
    }
    getScore(player) {
        return Math.floor(player.cardsInHand.length / 3);
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class ScientistsPolicy01 {
    constructor() {
        this.isDefault = true;
        this.id = TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_DEFAULT_POLICY;
        this.description = 'Pay 10 M€ to draw 3 cards';
    }
    canAct(player, isDominantPartyAction = false) {
        return player.canAfford(10) && player.canUseSingleTurmoilAction(isDominantPartyAction);
    }
    action(player, isDominantPartyAction = false) {
        const game = player.game;
        game.log('${0} used Turmoil ${1} action', (b) => b.player(player).card(new ScientistsDefaultAction_1.ScientistsDefaultAction()));
        game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 10, {
            title: 'Select how to pay for Turmoil Scientists action',
            afterPay: () => {
                player.drawCard(3);
                MarsCoalition_1.MarsCoalition.handleSingleUsePolicyLogic(player, isDominantPartyAction);
            },
        }));
        return undefined;
    }
}
class ScientistsPolicy02 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_POLICY_2;
        this.description = 'Your global requirements are +/- 2 steps';
        this.isDefault = false;
    }
}
class ScientistsPolicy03 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_POLICY_3;
        this.description = 'When you raise a global parameter, draw and discard a card per step raised';
        this.isDefault = false;
    }
}
class ScientistsPolicy04 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_POLICY_4;
        this.description = 'Cards with Science tag requirements cost 1 less tag to play';
        this.isDefault = false;
    }
    apply(game) {
        game.getPlayers().forEach((player) => {
            player.hasTurmoilScienceTagBonus = true;
        });
    }
}
exports.SCIENTISTS_BONUS_1 = new ScientistsBonus01();
exports.SCIENTISTS_BONUS_2 = new ScientistsBonus02();
exports.SCIENTISTS_DEFAULT_POLICY = new ScientistsPolicy01();
exports.SCIENTISTS_POLICY_2 = new ScientistsPolicy02();
exports.SCIENTISTS_POLICY_3 = new ScientistsPolicy03();
exports.SCIENTISTS_POLICY_4 = new ScientistsPolicy04();
//# sourceMappingURL=Scientists.js.map